import { render, staticRenderFns } from "./charge-view.vue?vue&type=template&id=8f4f8c6c&scoped=true"
import script from "./charge-view.vue?vue&type=script&lang=js"
export * from "./charge-view.vue?vue&type=script&lang=js"
import style0 from "./charge-view.vue?vue&type=style&index=0&id=8f4f8c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4f8c6c",
  null
  
)

export default component.exports